import { useEffect, useState } from 'react';

import useRequest from '@swf/core/hooks/useRequest';

const useAuthToken = (fallback: () => void): string => {
  const request = useRequest();
  const [token, setToken] = useState('');

  useEffect(() => {
    request({
      service: '/api/v1-preview/account/idscan/token',
      method: 'GET',
      http: true
    }).subscribe(
      ({ body }) => (body.token ? setToken(body.token) : fallback()),
      () => fallback()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return token;
};

export default useAuthToken;
